import React, { Component } from 'react';
import "./chart.css";

import {Bar} from 'react-chartjs-2'

export default class BarChart extends Component {

  // constructor(props) {
  //   super(props)
  //   this.
  // }
  state = { animationComplete: false }

  render() {

    let chartData = {
      labels: this.props.dataLabels,
      datasets: [
        {
          data: this.props.data,
          borderColor: "#e71272",
          borderWidth: 3,
        }
      ]
    }

    // Local clone of data to eliminate 'object not extensible' error
    chartData = JSON.parse(JSON.stringify(chartData))

    let component = this

    let options = {
      layout: {
        padding: {
          top: 20
        }
      },
      animation: {
        onProgress: (animation) => {
          let chartInstance = animation.chart
          let ctx = chartInstance.ctx;
          // ctx.font = this.scale.font;
          ctx.fillStyle = "#e71272"
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";


          chartInstance.data.datasets.forEach(function (dataset, i) {
            var meta = chartInstance.controller.getDatasetMeta(i);
            meta.data.forEach(function (bar, index) {
                let data = (dataset.data[index] * 100).toFixed(0) + '%'                        
                ctx.fillText(data, bar._model.x, bar._model.y - 3);
            });
          });
          // this.datasets.forEach(function (dataset) {
          //     dataset.bars.forEach(function (bar) {
          //         ctx.fillText(bar.value, bar.x, bar.y - 5);
          //     });
          // })
        },
      },
      scales: {
        xAxes: [{
          gridLines: { display: false },
          scaleLabel: {
            display: !!this.props.xLabel,
            labelString: this.props.xLabel
          },
          ticks: {
            minRotation: 0,
            maxRotation: 0,
            autoSkip: false,
          }
        }],
        yAxes: [{
          gridLines: { display: false },
          scaleLabel: {
            display: !!this.props.yLabel,
            labelString: this.props.yLabel
          },
          ticks: {
            type: 'linear',
            min: 0,
            maxTicksLimit: 5,
            callback: (val) => {
              // return val * 100 + '%'
              return ''
            }
          }
        }]
      },
      legend: {
        display: false,
      },
      tooltips: {
        enabled: false,
        yAlign: 'bottom',
        callbacks: {
          label: (item, data) => {
            return (item.index) + ' out of 100'
          },
          // title: (item, data) => {
          //   return "Your Response"
          // }
        }
      }
    }

    return (
      <div className="chart-background">
        { this.props.title }
        {/* <div className="line-histogram-user-position" style={{left: '30%'}}>
          30%
        </div> */}
        {/* <div className="line-histogram-legend">
          <span className="line-histogram-legend-dot" />
          You reported a anxiety level of 31 out of 100 
        </div> */}
        <Bar data={chartData} options={options} 
          style={{marginRight: 0, marginTop: '5px'}} 
        />
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/input/bar-chart.js